<template>
	<app-header v-if="!isLoading && !isPageNotFound" />
	<router-view />
	<app-footer v-if="!isPageNotFound && !isService" />
	<scroll-top v-if="!isPageNotFound" />
	<!-- <JoinOurTeam
		v-if="!isPageNotFound && !isPageWeAreHiring && !isSkillsCompetenceTest"
	/> -->
	<turn-stile
		:key="store.getTokenResetValue"
		@token-change="store.setTurnstyleToken"
	/>
	<CookieNotice />

	<Teleport v-if="cookies.consent.analytics" to="head">
		<component
			:is="'script'"
			async
			src="https://www.googletagmanager.com/gtag/js?id=G-61FYMN83RS"
		/>
		<component :is="'script'">
			window.dataLayer = window.dataLayer || []; function gtag() {
			dataLayer.push(arguments); } gtag("js", new Date()); gtag("config",
			"G-61FYMN83RS");
		</component>
	</Teleport>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useHead } from "@unhead/vue";
import { useDefaultStore } from "@/store";
import TurnStile from "@/components/helpers/TurnStile.vue";
import { useCookies } from "./assets/js/cookie";
import api from "./api";

const store = useDefaultStore();
const route = useRoute();

const cookies = useCookies();

const canonicalLink = computed(() => {
	const baseUrl = "https://enonsolutions.com";
	return baseUrl + route.path;
});

const routeMeta = {
	Home: {
		title: "ENON Solutions",
		description:
			"ENON Solutions is a company specialized in software development with a wide range of projects in its portfolio, including mobile phone applications, AI, IoT applications, as well as web applications.",
	},
	TeamPage: {
		title: "ENON Solutions Team",
		description:
			"ENON Solutions is a company specialized in software development with a wide range of projects in its portfolio, including mobile phone applications, AI, IoT applications, as well as web applications.",
	},
	Projects: {
		title: "ENON Solutions Projects",
		description:
			"Explore our completed projects and see how we help clients across various industries build products safely, professionally, and efficiently.",
		// "Feel free to discover our projects. We cover a wide range of niches and can help you build your product in a safe, professional, and efficient way.",
	},
	Technology: {
		title: "ENON Solutions Technologies",
		description:
			"Tailoring Software Technology to Customer Needs. Discover the technologies we use.",
	},
	Quote: {
		title: "ENON Solutions Quote",
		description:
			"Give us details on what you need, and our representative will contact you as soon as possible.",
	},
	QuoteContact: {
		title: "ENON Solutions Quote",
		description:
			"Give us details on what you need, and our representative will contact you as soon as possible.",
	},
	QuoteDone: {
		title: "ENON Solutions Quote",
		description:
			"Thank you for your interest in learning more about the website creation process!",
	},
	WeAreHiring: {
		title: "Business Development Manager - Application Form",
		description:
			"ENON Solutions is hiring! If you are a Business Developer interested in being a part of our team, please send your application.",
	},
	SkillsCompetenceTest: {
		title: "Sales and Entrepreneurial Skills Competence Test",
		description:
			"ENON Solutions is hiring! If you are a Business Developer interested in being a part of our team, please send your application.",
	},
	"not-found": {
		title: "Page Not Found - ENON Solutions",
		description: "The page you are looking for does not exist.",
	},
};

const meta = computed(() => {
	return (
		routeMeta[route.name as keyof typeof routeMeta] ?? {
			title: "ENON Solutions",
			description: "Software development company with modern solutions.",
		}
	);
});

function setupHead() {
	const noIndexPages = ["QuoteDone", "SkillsCompetenceTest", "not-found"];
	const isNoIndex = noIndexPages.includes(route.name as string);

	useHead({
		title: meta.value.title,
		meta: [
			{ name: "description", content: meta.value.description },
			{
				name: "robots",
				content: isNoIndex ? "noindex, nofollow" : "index, follow",
			},
			{ property: "og:title", content: meta.value.title },
			{ property: "og:description", content: meta.value.description },
			{ property: "og:image", content: "https://enonsolutions.com/logo.jpg" },
			{ property: "og:type", content: "website" },
			{ property: "og:site_name", content: "enonsolutions.com" },
		],
		link: [{ rel: "canonical", href: canonicalLink.value }],
	});
}

watch(canonicalLink, () => {
	setupHead();
});

const isSkillsCompetenceTest = computed(() => {
	if (route.name === "SkillsCompetenceTest") {
		return true;
	} else {
		return false;
	}
});

const isPageNotFound = computed(() => {
	if (route.name === "not-found") {
		return true;
	} else {
		return false;
	}
});
const isService = computed(() => {
	if (route.name === "Services") {
		return true;
	}
	return false;
});

const isPageWeAreHiring = computed(() => {
	if (route.name === "WeAreHiring") {
		return true;
	} else {
		return false;
	}
});

watch(
	() => isService.value,
	(newVal) => {
		if (newVal) {
			document.body.style.minHeight = "calc(100vh - 100px)";
		} else {
			document.body.style.minHeight = "100vh";
		}
	},
);
onMounted(async () => {
	checkInternshipStatus();
	store.userReferrer = document.referrer;
	if (route.name === "Services") {
		document.body.style.minHeight = "calc(100vh - 100px)";
	}
});

const isLoading = ref(true);

async function checkInternshipStatus() {
	try {
		const res = await api.getInternshipStatus();
		store.setInternship(res.data.data);
	} catch (e) {
		console.log(e);
	} finally {
		isLoading.value = false;
	}
}
</script>

<style lang="scss">
@import "./assets/css/base.css";

.grecaptcha-badge {
	visibility: hidden;
	opacity: 0;
}

@font-face {
	font-family: Archivo;
	font-weight: 600;
	src:
		local("Archivo"),
		url("./assets/fonts/archivo.ttf") format("truetype");
}

.wrapper {
	max-width: 1500px;
	margin: 0 auto;
}
html {
	scroll-behavior: smooth;
}

#app {
	height: 100%;
	// overflow-x: hidden;
}
</style>
